import React from "react";
import { ArrowRight, TrendingUp } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_derya-stock-picks/artifacts/pfxn3raj_SnapInsta.to_523547509_18514072933058180_7858186581373202314_n.jpg";

export default function Hero({ telegramUrl }) {
  return (
    <section
      id="anasayfa"
      className="relative min-h-screen flex items-center overflow-hidden pt-24"
      data-testid="hero-section"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMG}
          alt="Derya Eliz Yıldız - Borsa ve Piyasa Analisti"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="absolute inset-0 grain" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 lg:px-16 w-full grid lg:grid-cols-12 gap-10 items-center pb-20">
        <div className="lg:col-span-8">
          <div
            className="chip-gold animate-fade-up"
            data-testid="hero-eyebrow"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#d4af37] animate-pulse-gold" />
            Borsa · Yatırım · Analiz
          </div>

          <h1
            className="font-serif text-white text-[clamp(2.5rem,6.4vw,5.25rem)] leading-[1.05] mt-6 animate-fade-up delay-100"
            data-testid="hero-title"
          >
            <span className="block">Derya Eliz Yıldız ile</span>
            <span className="block italic text-gold-gradient">
              Borsa Piyasalarını
            </span>
            <span className="block">Daha Yakından Takip Edin</span>
          </h1>

          <p
            className="mt-7 max-w-2xl text-[#cbd5e1] text-lg md:text-xl font-light leading-relaxed animate-fade-up delay-200"
            data-testid="hero-subtitle"
          >
            6 yıllık piyasa deneyimiyle{" "}
            <span className="text-white">günlük fırsat hisseler</span>, borsa
            bilgilendirmeleri ve{" "}
            <span className="text-white">özel analiz içerikleri</span>.
          </p>

          <div
            className="mt-10 flex flex-wrap gap-4 animate-fade-up delay-300"
            data-testid="hero-cta-group"
          >
            <a
              href={telegramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold px-7 py-4 rounded-full inline-flex items-center gap-2.5 text-[15px]"
              data-testid="hero-telegram-btn"
            >
              <i className="fa-brands fa-telegram text-lg" />
              Telegram VIP Grubuna Katıl
              <ArrowRight size={18} />
            </a>
            <a
              href="#borsa-bilgilendirmeleri"
              className="btn-ghost px-7 py-4 rounded-full inline-flex items-center gap-2.5 text-[15px]"
              data-testid="hero-opportunities-btn"
            >
              <TrendingUp size={18} />
              Günlük Fırsat Hisseleri Gör
            </a>
          </div>

          {/* Trust strip */}
          <div
            className="mt-14 grid grid-cols-3 gap-6 max-w-xl animate-fade-up delay-500"
            data-testid="hero-stats"
          >
            {[
              { v: "6+", l: "Yıl Deneyim" },
              { v: "%91", l: "İsabet Oranı*" },
              { v: "7/24", l: "Piyasa Takibi" },
            ].map((s) => (
              <div key={s.l} className="border-l border-[#d4af37]/30 pl-4">
                <div className="font-serif text-3xl md:text-4xl text-white">
                  {s.v}
                </div>
                <div className="text-[11px] tracking-[0.18em] uppercase text-[#94a3b8] mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
          <p className="mt-3 text-[10px] text-[#64748b] tracking-wide animate-fade-up delay-600">
            *Geçmiş paylaşımlara dayalıdır, yatırım tavsiyesi değildir.
          </p>
        </div>

        {/* Vertical accent on the right */}
        <div className="hidden lg:flex lg:col-span-4 justify-end items-end pb-6">
          <div className="text-right animate-fade-up delay-400">
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#d4af37] mb-3">
              EST · 2018
            </div>
            <div className="font-serif text-white text-2xl leading-tight">
              <em>"Piyasalar, sabırlı olanları ödüllendirir."</em>
            </div>
            <div className="mt-3 text-[#94a3b8] text-xs tracking-wider">
              — DERYA ELİZ YILDIZ
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-[#94a3b8] text-[10px] tracking-[0.4em] flex flex-col items-center gap-2 animate-fade-in delay-700">
        AŞAĞI KAYDIR
        <div className="w-px h-10 bg-gradient-to-b from-[#d4af37] to-transparent" />
      </div>
    </section>
  );
}
